import { useAppNavigation } from 'hooks/useAppNavigate';
import dict from 'locales/dict';
import { useTranslation } from 'react-i18next';

export function ButtonBack({ className = '' }: any) {
  const navigate = useAppNavigation();
  const { t } = useTranslation();

  return (
    <div className='flex gap-x-6'>
      <span
        className={`relative z-10 rounded-full bg-gray-50 px-3 py-1.5 text-medium text-brand-content hover:bg-gray-100 cursor-pointer ${className}`}
        onClick={() => navigate.back()}
      >
        {t(dict.back)}
      </span>
    </div>
  );
}
